var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      [
        _c("SectionHeader", {
          attrs: { title: "Risks and Alerts", currentUser: _vm.currentUser },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoSection",
          [
            _c("InfoField", {
              attrs: {
                label: "Fall Risk",
                value: _vm.data.fall_risk,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Infectious Diseases",
                value: _vm.data.infectious_diseases,
                defaultText: "N/A",
              },
            }),
            _c(
              "InfoField",
              { attrs: { label: "Substance Use Considerations" } },
              [
                _c("div", [
                  _c(
                    "p",
                    { staticClass: "text-gray-400 text-xs md:text-sm mb-1" },
                    [
                      _vm._v(
                        " (History of alcohol or drug misuse, requiring sensitivity and support) "
                      ),
                    ]
                  ),
                  _c("p", { staticClass: "text-gray-600" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.data.substance_use_considerations || "N/A") +
                        " "
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "AllergiesSection",
              { attrs: { title: "Allergies" } },
              [
                _c("AllergyCategory", {
                  attrs: {
                    title: "Food",
                    allergies: _vm.formatAllergies(_vm.data.allergy_food),
                    emptyText: "N/A",
                  },
                }),
                _c("AllergyCategory", {
                  attrs: {
                    title: "Medication",
                    allergies: _vm.formatAllergies(_vm.data.allergy_medication),
                    emptyText: "N/A",
                  },
                }),
                _c("AllergyCategory", {
                  attrs: {
                    title: "Environmental",
                    allergies: _vm.formatAllergies(
                      _vm.data.allergy_environmental
                    ),
                    emptyText: "N/A",
                  },
                }),
              ],
              1
            ),
            _c("InfoField", { attrs: { label: "DNR (Do Not Resuscitate)" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _c("span", { staticClass: "capitalize" }, [
                  _vm._v(
                    "DNR (Do Not Resuscitate): " +
                      _vm._s(_vm.proejctData.dnr_order || "N/A")
                  ),
                ]),
                _c("br"),
                _vm._v(
                  " Copy Attached: " +
                    _vm._s(_vm.proejctData.dnr_copy_attached ? "Yes" : "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Precautions" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Description: " +
                    _vm._s(_vm.data.precautions_description || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Related Notes: " +
                    _vm._s(_vm.data.precautions_related_notes || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", {
              attrs: {
                label: "General Notes",
                value: _vm.data.precautions_general_notes,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }